<div class="info-message info-coach">
  <div class="info-coach-icon"></div>
  <div class="info-coach-message">Rearrange form elements by clicking and dragging.  Select a field to edit its content or properties.</div>
</div>

<div class="editable-fields-container {{#unless fields}}no-fields{{/unless}}">
  {{#if fields}}
    {{#each fields}}
      <div data-behaviour="editable-field" class="editable-field input-wrapper reorderable {{ type }} {{#if size}}--size-{{size}}{{/if}} {{#equal @key ../selected_index }}selected{{/equal}}" data-index="{{ @key }}">

        <div class="cover"></div>

        <div>
          {{> (fbPartial . "type") preview="true" }}
        </div>
        <button class="form-field-template-item-delete">
          {{{ icon 'close-alt-color' }}}
        </button>
      </div>
    {{/each}}
  {{/if}}
</div>

{{#if fields}}
  <div data-behaviour="submit-field" class="input-wrapper fields-container-submit-container disabled">
    <div class="cover"></div>

    <div>
      <input class="fields-container-submit-input" type="submit" value="{{submit_text}}">
    </div>
  </div>
{{/if}}
